import { FormattedMessage, useIntl } from 'react-intl'
import ErrorPopup from '../../../../components/error'
import {
  ErrorMessage,
  ErrorMessageBlock,
  LabelMessage
} from '../../../../components/form-fields/styled-components'

const LoginErrors = ({
  browser,
  loginError,
  params,
  emailWrong,
  emailVerified,
  emailVerifying
}) => {
  const { formatMessage } = useIntl()

  const browserNotSupported = !(
    (browser.name === 'chrome' &&
      Number(browser.version.split('.')[0]) >= 60) ||
    (browser.name === 'firefox' &&
      Number(browser.version.split('.')[0]) >= 56) ||
    (browser.name === 'edge-chromium' &&
      Number(browser.version.split('.')[0]) >= 79) ||
    (browser.name === 'safari' &&
      Number(browser.version.split('.')[0]) >= 11) ||
    (browser.name === 'ios' && Number(browser.version.split('.')[0]) >= 11) ||
    (browser.name === 'crios' && Number(browser.version.split('.')[0]) >= 60) ||
    (browser.name === 'fxios' && Number(browser.version.split('.')[0]) >= 9)
  )

  const handleGetErrorMessageId = (loginError) => {
    if (
      loginError &&
      loginError.response &&
      loginError.response.status === 400
    ) {
      return `registerForm_${loginError.response.data.error_description?.replace(
        / /g,
        '_'
      )}`
    }
    return undefined
  }

  const errorMessageId = handleGetErrorMessageId(loginError)

  return (
    <ErrorMessageBlock>
      {errorMessageId && (
        <ErrorMessage data-testid="Login-errorMsg-wrongCredentials">
          <FormattedMessage
            id={errorMessageId}
            defaultMessage={formatMessage({
              id: 'registerForm_wrongCredentials'
            })}
          />
        </ErrorMessage>
      )}
      {params && params.mode === 'activated' && (
        <LabelMessage>
          <FormattedMessage id="registerForm_activationSuccessful" />
        </LabelMessage>
      )}
      {!errorMessageId && loginError && <ErrorPopup error={loginError} />}
      {emailVerifying && (
        <LabelMessage>
          <FormattedMessage id="registerForm_emailVerifying" />
        </LabelMessage>
      )}
      {emailWrong && (
        <ErrorMessage>
          <FormattedMessage id="registerForm_emailVerifyingWrong" />
        </ErrorMessage>
      )}
      {emailVerified && (
        <LabelMessage>
          <FormattedMessage id="registerForm_emailVerified" />
        </LabelMessage>
      )}
      {browserNotSupported && (
        <LabelMessage>
          <FormattedMessage id="browserNotSupported" />
        </LabelMessage>
      )}
    </ErrorMessageBlock>
  )
}

export default LoginErrors
